<template>
  <div class="list-item">
    <!-- 主评论 -->
    <div class="item-main">
      <div class="item-func clearfix">
        <!-- 左侧图标 -->
        <span
          class="comment-icon"
          @dblclick="dbClickIcon"
        >
          <i
            class="ricon-team"
            :style="{background: item.currentUser.color}"
          >{{ item.currentUser.user_name.substring(0,1) }}</i>
          <div class="info-box">
            <div class="info-box-name"><span class="info-title">{{ $t('用户名：') }}</span> <span class="info-content">{{ item.currentUser.user_name }}</span></div>
            <div class="info-box-email"><span class="info-title">{{ $t('邮箱：') }}</span> <span class="info-content">{{ item.currentUser.email }}</span></div>
          </div>
        </span>
        <!-- 名字 -->
        <div class="comment-info">
          <h4 class="comment-name">
            {{ item.currentUser.user_name }}
          </h4>
        </div>
      </div>

      <div
        class="item-footer"
        v-html="formatContent(item)"
      />

      <!-- 删除提示 -->
      <delete-dialog
        v-show="isShowPop"
        @cancle="hideDeleteConfirm"
        @confirm="deleteItem"
      />
      <div class="commnet-footer">
        <span class="comment-time">
          {{timerHandler(item.ctime)}}
        </span>
        <span
          @click="popDeleteConfirm()"
          v-show="sameCreator || Util.isCustomAdministrator(100)"
          class="ml-8 cp"
        >
        {{ $t('删除') }}
        </span>
        <span
          @click="replyComment(item)"
          v-show="isShowReply && !sameCreator"
          class="ml-8 cp"
        >
        {{ $t('回复') }}
        </span>
      </div>
    </div>


    <!-- 回复区，楼中楼 -->
    <div
      v-if="replyNum > 0"
      class="replies"
      :class="{'deleting': isShowPop}"
    >
      <!-- 多条回复收起时 -->
      <div
        v-if="!isToogle"
        class="last-content"
      >
        <span
          class="name"
          :title="getLastItem.currentUser ? getLastItem.currentUser.user_name : ''"
        >{{ getLastItem.currentUser ? getLastItem.currentUser.user_name : '' }}</span>:
        <span class="content">{{ getLastItem.content || '' }}</span>
        <div>
          <div
            class="comment-time-o"
            v-html="timerHandler(getLastItem.ctime || 0)"
          />
          <span
            v-show="!isSameCreator(getLastItem || {})"
            class="reply-btn"
            @click="replyComment(getLastItem || {})"
          >{{ $t('回复') }}</span>
          <span
            v-show="isSameCreator(getLastItem || {}) || isAdmin"
            class="reply-btn"
            @click="modifyComments({type: 'delete', data: (getLastItem || {})})"
          >{{ $t('删除') }}</span>
        </div>
      </div>

      <!-- 回复展示时 -->
      <ul
        v-show="isToogle"
        class="reply"
      >
        <li
          v-for="(replyItem,index) in repliesData"
          :key="index"
          class="reply-item"
        >
          <reply-item
            :item="replyItem"
            :index="index"
            @replyComment="replyComment"
            @modifyComments="modifyComments"
          />
        </li>
      </ul>
      <div
        v-show="replyNum > 1"
        class="toogle-replies"
        @click="toogleReply()"
      >
        {{ isToogle?toogleTitles[1]:toogleTitles[0] }}
      </div>
    </div>
    <!--<div class="item-line"></div>-->
    <!-- 当删除时，和取消评论时增加遮照 -->
    <div
      v-show="isShowPop"
      ref="commentMask"
      class="comment-mask"
      @click="isShowPop = false"
    />
  </div>
</template>
<script>
import * as Util from 'js/util/util'
import _$ from 'js/api/getdata'
import store from 'store'
import ReplyItem from './reply-item.vue'
import DeleteDialog from './delete-dialog.vue'

export default {
  name: 'CommentItem',
  components: {
    ReplyItem,
    DeleteDialog,
  },
  props: ['item', 'updateData'],
  data() {
    return {
      Util,
      isRepliesShow: true,
      repliesData: [],
      isToogle: false,
      isShowPop: false,
      isShowReply: true,
    }
  },
  computed: {
    selectedData() {
      return store.state.curFileInfo
    },
    isAdmin() {
      return store.getters.userInfo && store.getters.userInfo.role === 'admin'
    },
    getLastItem() {
      return this.repliesData[this.repliesData.length - 1] || {}
    },
    toogleTitles() {
      return [
        this.$t('查看{n}条回复', { n: this.replyNum }),
        this.$t('收起更多'),
      ]
    },
    replyNum() {
      return this.repliesData.length || 0 // || this.item.replyNum;
    },
    sameCreator() {
      return this.item.currentUser.user_name === store.state.lenovoData.LenovoData.userinfo.user_name
    },
    isShowDelete() {
      return true
    },
  },
  watch: {
    updateData(value) {
      if (value) {
        this.isToogle = true
      }
    },
    isShowPop(n) {
      if (n) {
        this.locateMask()
      }
    },
  },
  methods: {
    isSameCreator(data) {
      if (data.currentUser) {
        if (data.currentUser.uid === store.getters.userInfo.uid) {
          return true
        }
      }
      return false
    },
    formatContent(data) {
      const reg = /@\S+/g
      let result = data.content.words.match(reg) || []
      result = result.map((v, key) => {
        if (data.a_list.length === 0 || data.a_list[key] === '' || data.a_list[key] === undefined) {
          return v
        }
        return `<span style="color: #2C7DF1;cursor: pointer;font-size:13px">${v}</span>`
      })
      const text = data.content.words.split(reg)
      let contextReturn = ''
      for (let i = 0; i < text.length; i += 1) {
        contextReturn += text[i] + (result[i] || '')
      }
      return contextReturn
    },
    toogleReply() {
      this.isToogle = !this.isToogle
    },
    popDeleteConfirm() {
      this.isShowPop = true
    },
    hideDeleteConfirm() {
      this.isShowPop = false
    },
    dbClickIcon() { // 双击头像回复
      this.replyComment(this.item)
    },
    deleteItem() {
      this.$emit('modifyComments', {
        type: 'delete',
        data: this.item,
      })
      this.isShowPop = false
    },
    replyComment(value) {
      this.$emit('replyComment', value)
    },
    modifyComments({ type, data }) {
      if (type === 'delete') {
        const commentId = {
          comment_id: data.id,
        }
        _$.postData('deleteComment', commentId).then((res) => {
          const idx = this.repliesData.indexOf(data)
          this.repliesData.splice(idx, 1)
        }).catch((error) => {
          const err = error.response.data
          window.$toast.simpleShow(err.message, 'error')
        })
      }
    },
    getReply() {
      const data = {
        neid: this.selectedData.neid,
        _: Date.parse(new Date()),
        account_id: store.getters.accountId,
        uid: store.getters.uId,
        offset: 0,
        limit: 20,
        commentId: this.item.id,
      }
      _$.getData('getReply', data).then((res) => {
        const da = res.data.comments
        da.reverse()
        this.repliesData = da
      }).catch((error) => {
        if (error.response) {
          const err = error.response.data
          this.$store.commit('GET_TOAST_INFO', { info: err.message, tipsType: 'error' })
        }
      })
    },
    timerHandler(originTime) {
      return Util.timeago(originTime)
    },
    /**
         * 定位遮照，用于取消删除提示
         */
    locateMask() {
      // 算浏览器的宽度
      const rDom = document.getElementsByClassName('preview-box-body-right')
      const rBound = rDom[0].getBoundingClientRect()
      // let rWith = rDom[0].offsetWidth
      const { commentMask } = this.$refs
      commentMask.style.top = `${rBound.top}px`
      commentMask.style.left = `${rBound.left}px`

      // 算右侧栏的宽度
    },
  },
}
</script>

<style lang="less" scoped>
// @import '~less/reset.less';
.comment-mask {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  z-index: 11;
}
.list-item {
  // display: inline;
  position: relative;
  /*padding-left: 6px;*/
  padding-top: 7px;
  padding-bottom: 7px;
  white-space:normal;
  word-break: break-all;
  .item-func{
    font-size: 12px;
    // height: 18px;
    position: relative;
    line-height: 24px;
  }
  .comment-icon {
    float: left;
    .ricon-team {
      display: block;
      width: 24px;
      height: 24px;
      color: #fff;
      line-height: 24px;
      border-radius: 24px;
      text-align: center;
      // background: transparent;
      position: relative;
    }
    .info-box {
      display: none;
      position: absolute;
      top: 36px;
      left: 2px;
      padding: 8px 12px;
      width: 213px;
      background: #fff;
      border: 1px solid #FCFCFC;
      box-shadow: 0 1px 3px 1px rgba(0, 0, 0, 0.18);
      border-radius: 1px;
      z-index: 100;
      cursor: pointer;
      font-size: 12px;
      div {
        font-size: 12px;
        color: #0E2641;
        &::after {
          content: "";
          clear: both;
          display: table;
        }
      }
      .info-box-email{
        margin-top: 10px;
      }
      .info-title{
        width: 60px;
        text-align: right;
        float: left;
      }
      .info-content{
        width: 150px;
        word-wrap: normal;
        word-break: break-all;
        float: left;
      }
    }
  }
  .comment-icon:hover {
    .info-box {
      display: block;
    }
  }
  .comment-info {
    float: left;
    width: 140px;
    margin-left: 12px;
    .comment-name {
      font-size: 14px;
      font-weight: normal;
      color: #3e3e3e;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }

  }
  .comment-time {
    color: #929ca9;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .comment-time-o {
    /*margin-top: 5px;*/
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 12px;
    color: #929CA9;
    display: inline-block;
    /*width: 200px;*/

  }
  .reply-btn{
    display: inline-block;
    cursor: pointer;
    font-size: 12px;
    vertical-align: top;
    margin-left: 8px;
    color:#1B2733;
  }
  .comment-more {
    margin-top: 3px;
    margin-right: 12px;
    float: right;
    .ricon-more{
      display: inline-block;
      width: 18px;
      height: 18px;
      // background: url(./../images/file_attr_right.png) no-repeat scroll 0 0 transparent;
      background-position: -168px -18px;
      cursor: pointer;
    }
  }
  .item-footer {
    color: #67707c;
    font-size: 13px;
    line-height: 17px;
    margin: 0px 8px 0px 36px;
    word-break: break-all;
    word-wrap: normal;
  }
  .item-line {
    width: 100%;
    border-top: 1px solid #EAEAEA;
  }
}
.format-content {
  color: #2C7DF1;
  cursor: pointer;
}
.item-main::after {
  content: "";
  clear: both;
  display: table;
}
.delete-dialog {
  background: #637282;
  border-radius: 1px;
  height: 24px;
  overflow: hidden;
  padding: 0 6px;
  position: absolute;
  // top: -3px;
  // left: -84px;
  // width: 210px;        z-index: 999;
  .dialog-title {
    margin-top: 17px;
    margin-bottom: 9px;
    font-size: 12px;
    color: #0E2641;
    text-align: center;
  }
  .dialog-btn {
    text-align: center;
    .dialog-confirm {
      display: inline-block;
      width: 54px;
      height: 24px;
      font-size: 12px;
      line-height: 24px;
      color: #fff;
      background: #2C7DF1;
      border: 1px solid #2C7DF1;
      border-radius: 2px;
      cursor: pointer;
    }
    .dialog-cancle {
      margin-left: 8px;
      display: inline-block;
      width: 54px;
      height: 24px;
      line-height: 24px;
      font-size: 12px;
      border: 1px solid #AEAEAE;
      border-radius: 2px;
      cursor: pointer;
    }
  }
}
.replies {
  display: block;
  background: #F6F7FA;
  border-radius: 2px;
  padding: 8px;
  margin-left: 36px;
  .toogle-replies {
    color: #1b2733;
    cursor: pointer;
    font-size: 12px;
    text-align: right;
  }
  .reply {
    display: block;
  }
  .reply-item{
    margin-bottom: 10px;
  }
  .last-content{
    /*padding-left: 10px;*/
    .name, .content{
      font-size: 12px;
      color: #1B2733;
      line-height: 17px;
    }
    .name {
      // width: 60px;
      display: inline-block;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      vertical-align: bottom;
    }
    .content{
      color: #637282;
    }
  }
}
.deleting{
  opacity: .4;
}
.commnet-footer {
  padding-left: 36px;
  font-size: 12px;
}
.ml-8 {
  margin-left: 8px;
}
</style>
